import WeekView from './WeekView';

export default function CalendarHeader({
    view,
    setView,
    selectedDate,
    setSelectedDate,
    calYear,
    isMobile,
    prevNav,
    nextNav,
    headerTitle,
    tuition,
    onBack
}) {
    return (
        <div className={`calendar-header ${isMobile ? 'calendar-header-mobile' : 'calendar-header-desktop'}`}>
            <div className="header-mobile-top">
                <button className="header-back-btn" onClick={onBack}>←</button>
                <span className="header-page-title">Attendance</span>
            </div>

            <div className="header-main">
                <div className='title-wrapper'>
                    <div className={`header-title ${isMobile ? 'mobile' : ''}`}>
                        {tuition ? `${tuition.student_name} - ${tuition.subject}` : "Attendance Details"}
                    </div>
                    <div className={`header-subtitle ${isMobile ? 'mobile' : ''}`}>{headerTitle()}</div>
                </div>
                <div className="view-selector-container">
                    <select
                        value={view}
                        onChange={e => setView(e.target.value)}
                        className="view-selector"
                    >
                        <option value="week">Week</option>
                        <option value="month">Month</option>
                        <option value="year">Year</option>
                    </select>
                </div>
            </div>

            <div className='header-devider' />
            {view === "week" && (
                <WeekView selectedDate={selectedDate} onSelectDate={setSelectedDate} />
            )}

            {(view === "month" || view === "year") && (
                <div className="header-nav">
                    {view === "year" && (
                        <>
                            <button onClick={prevNav} className="nav-btn">‹</button>
                            <span className="header-year-label">{calYear}</span>
                            <button onClick={nextNav} className="nav-btn">›</button>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}
